import React, { useState } from "react";
import { useForm } from "react-hook-form";
import  CONSTANTS  from "../../utils/constants";
import NavButton from "../portico/button/button";
import CustomLoading from "../custom/custom-loading";

interface ManualTaskDetailsProps {
  readOnly : boolean,
  journeyId: string,
  entityDraft : any,
  currentTask : any,
  completeTask : Function
}

export const ManualTaskDetails: React.FC<ManualTaskDetailsProps> = ({completeTask}) => {
  const [submitting, setSubmitting] = useState<boolean>(false);
  const { handleSubmit } = useForm();
  
  const onSaveClicked = async () => {
    setSubmitting(true);

    await completeTask();

    setSubmitting(false);
  };

  return (
    <>
      {/* <LoadingOnBackdrop status={submitting} message="Saving data" /> */}
      {submitting && <CustomLoading message="Saving data..." />}
      <form onSubmit={handleSubmit(onSaveClicked)}>
        <>Manual Task - Work in Progress</>
        <NavButton buttonLabel={CONSTANTS.SAVE_CONTINUE} />
      </form>
    </>
  );
};
